import React, { Component } from 'react'
import { connect } from 'react-redux'

import './carRental.scss'

// Components
import DecimalInput from '../../../shared/components/DecimalInput'
// import HelpText from '../../../shared/components/HelpText'

import Row from '../../../shared/elements/row'
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Radio from '../../../shared/elements/radio'
import Switch from '../../../shared/elements/switch'
import Text from '../../../shared/elements/text'
import Textarea from '../../../shared/elements/textarea'
import Check from '../../../shared/elements/check'
import Grid from '../../../shared/elements/grid'
import AddButton from '../../../shared/elements/addButton'
import RemoveButton from '../../../shared/elements/removeButton'
import Label from '../../../shared/elements/label'
import DropDown from '../../../shared/elements/dropDown'
import Portal from '../../../shared/components/Portal'
import Confirm from '../../../shared/components/Confirm'

import { translation } from '../../../utils/helpers'

// contants
import { CarRentalSystemTypes } from '../../../constants'

// Actions
import { getCarRentalInformation, saveCarRentalInformation } from '../../../actions/settings'

class CarRental extends Component {
  constructor (props) {
    super(props)

    this.state = {
      Identification: 0,
      BufferBefore: 0,
      BufferAfter: 0,
      ShowClosedDays: false,
      Show24Hours: false,
      StandardConditions: '',
      StandardPrice: 0,
      CarRentalAlts: [],
      NewItem: {
        Id: 0,
        Name: '',
        Active: false,
        IsDeleted: false
      },
      CarRentalSystem: CarRentalSystemTypes.NONE,
      RentLogUserName: '',
      RentLogPassword: '',
      CarRentalCredentialsError: false,
      SelectedBranchOffice: '',
      BranchOfficeListFromRentLog: [],
      RentLogBranchOfficeInfos: [],
      RentLogDepartmentInfos: [],
      DepartmentListFromRentLog: [],
      textKey: 0,
      showPopup: false,
      selectedRentLog: CarRentalSystemTypes.NONE
    }

    this.onBlur = this.onBlur.bind(this)
    this.renderIdentification = this.renderIdentification.bind(this)
    this.renderBuffer = this.renderBuffer.bind(this)
    this.renderView = this.renderView.bind(this)
    this.renderContract = this.renderContract.bind(this)
    this.renderAlternatives = this.renderAlternatives.bind(this)
    this.updateStateFromResponse = this.updateStateFromResponse.bind(this)
    this.renderIntegration = this.renderRentLogIntegration.bind(this)
  }

  componentDidMount () {
    this.props.getCarRentalInformation(this.props.auth.user.ShopId)
      .then(this.updateStateFromResponse)
      .catch(err => {
        console.error('CarRental settings', err)
      })
  }

  updateStateFromResponse (res) {
    const { data: { Identification, BufferBefore, BufferAfter, ShowClosedDays, Show24Hours, StandardConditions, StandardPrice, CarRentalAlts, CarRentalSystem, RentLogUserName, RentLogPassword, CarRentalCredentialsError, BranchOfficeListFromRentLog, RentLogBranchOfficeInfos, RentLogDepartmentInfos, DepartmentListFromRentLog } } = res
    this.setState({
      Identification,
      BufferBefore,
      BufferAfter,
      ShowClosedDays,
      Show24Hours,
      StandardConditions,
      StandardPrice,
      CarRentalAlts,
      NewItem: {
        Id: 0,
        Name: '',
        Active: false,
        IsDeleted: false
      },
      CarRentalSystem,
      RentLogUserName,
      RentLogPassword,
      CarRentalCredentialsError,
      RentLogBranchOfficeInfos,
      BranchOfficeListFromRentLog,
      RentLogDepartmentInfos,
      DepartmentListFromRentLog,
      showPopup: false
    })
  }

  onBlur () {
    this.props.saveCarRentalInformation(this.state)
      .then(res => {
        this.updateStateFromResponse(res)
        // window.toastr.success(translation('15125'), translation('13424'))
      })
      .catch(() => {
        window.toastr.error(translation('960'), translation('216'))
      })
  }

  renderBrancheOfficeListFromRentLog () {
    let { BranchOfficeListFromRentLog, RentLogBranchOfficeInfos, SelectedBranchOffice, DepartmentListFromRentLog } = this.state
    let cols = ['auto', '48px']
    let depGridCols = '1fr 1fr 1fr'

    const onClick = () => {
      let newBranchOffice = {
        RentLogBranchOffice: 0,
        CompanyId: this.props.auth.user.ShopId,
        BranchOfficeOId: this.state.SelectedBranchOffice,
        IsDeleted: false
      }

      if (newBranchOffice.BranchOfficeOId) {
        this.setState({
          RentLogBranchOfficeInfos: [newBranchOffice]
        }, () => {
          this.onBlur()
        })
      }
      SelectedBranchOffice = ''
    }

    const onChange = (e) => {
      this.setState({
        [e.target.name]: e.target.value
      })
    }

    const renderSelectedBranOffice = (branchOffice, key) => {
      const onDelete = _ => {
        branchOffice.IsDeleted = true
        this.setState({
          RentLogBranchOfficeInfos: [...RentLogBranchOfficeInfos]
        }, () => this.onBlur())
      }

      let name = ''
      BranchOfficeListFromRentLog.map((val) => {
        if (val.Oid === branchOffice.BranchOfficeOId) {
          name = val.Name
        }
      })

      // Department section
      // if the branch has been selected, it will be part of the selected branch office
      const renderDepartments = (department, Dkey) => {
        var thisDepartment = branchOffice.RentLogDepartmentInfos && branchOffice.RentLogDepartmentInfos.find((d) => d.DepartmentOId === department.Oid)
        let departmentInfo = {
          CompanyId: this.props.auth.user.ShopId,
          Active: thisDepartment !== undefined ? thisDepartment.Active : false,
          RentLogBranchOfficeId: branchOffice.RentLogBranchOffice,
          DepartmentOId: department.Oid,
          RentLogDepartmentId: thisDepartment !== undefined ? thisDepartment.RentLogDepartmentId : 0,
          Name: thisDepartment !== undefined && thisDepartment.Name ? thisDepartment.Name : department.Name
        }

        const onDeparmentChange = (e) => {
          departmentInfo = {
            ...departmentInfo,
            Active: e.target.checked
          }
          this.setState({
            RentLogDepartmentInfos: [departmentInfo]
          }, () => {
            this.onBlur()
          })
        }

        const onDepartmentNameChange = (e) => {
          departmentInfo = {
            ...departmentInfo,
            Name: e.target.value
          }

          this.setState({
            RentLogDepartmentInfos: [departmentInfo]
          })
        }

        // get the section name and active state if the user has selected department
        let departmentName = department.Name
        let selectedDeparment = false
        branchOffice.RentLogDepartmentInfos && branchOffice.RentLogDepartmentInfos.map((val) => {
          if (val.DepartmentOId === department.Oid) {
            departmentName = department.Name
            selectedDeparment = val.Active
          }
        })

        return (
          <Grid key={Dkey} cols={this.gridCols} spacing={1}>
            <Label>{departmentName}</Label>
            <Switch name={'department_' + Dkey} id={Dkey} onChange={onDeparmentChange} checked={selectedDeparment} spacing={0} />
            <Text name={'Text_' + Dkey} defaultValue={departmentInfo.Name} onChange={onDepartmentNameChange} onBlur={this.onBlur} disabled={!selectedDeparment} size='m' />
          </Grid>
        )
      }

      return (
        <div key={key} className='branchOffice-department'>
          <Grid key={key} cols={cols} spacing={1}>
            <Label>{name}</Label>
            <RemoveButton onClick={onDelete} size='m' />
          </Grid>
          <Grid cols={depGridCols} align='center'>
            <LabelWrapper labelText={translation('626')} />
            <LabelWrapper labelText={translation('1780')} />
            <LabelWrapper labelText={translation('18396')} />
          </Grid>

          {DepartmentListFromRentLog.map(renderDepartments)}
        </div>
      )
    }

    let branchOfficeListFromRentLog = []
    if (RentLogBranchOfficeInfos.length < 1) branchOfficeListFromRentLog.push({ Oid: 0, Name: translation('890') })

    BranchOfficeListFromRentLog.map((val) => {
      branchOfficeListFromRentLog.push({ Oid: val.Oid, Name: val.Name })
    })
    const branchOfficeOptions = branchOfficeListFromRentLog.map((b, index) => {
      return <option key={index} value={b.Oid}>{b.Name}</option>
    })

    return (
      <div>
        {RentLogBranchOfficeInfos.map(renderSelectedBranOffice)}
        {translation('18131')}
        <Grid cols={cols} spacing={1}>
          <DropDown name='SelectedBranchOffice' value={SelectedBranchOffice} onChange={onChange} >
            {branchOfficeOptions}
          </DropDown>
          <AddButton onClick={onClick} />
        </Grid>
      </div>
    )
  }

  renderPopupMessage () {
    const { showPopup, textKey, selectedRentLog } = this.state

    const onConfirm = () => {
      this.setState({
        showPopup: false,
        CarRentalSystem: selectedRentLog
      }, () => this.onBlur())
    }
    const onPortalClose = () => {
      this.setState({
        showPopup: false
      })
    }

    return (
      <div>
        {showPopup && (
          <Portal className='confirm_popup' onPortalClose={onPortalClose.bind(this)}>
            <Confirm
              renderText={() => { return translation(textKey) }}
              confirm={onConfirm.bind(this)}
              notConfirm={onPortalClose.bind(this)} />
          </Portal>
        )}
      </div>
    )
  }

  renderRentLogIntegration () {
    const {CarRentalSystem, RentLogUserName, RentLogPassword} = this.state
    const onChange = (e) => {
      const { value, name, type, checked } = e.target
      let val = value
      let popup = false
      let text
      if (type === 'checkbox') {
        if (checked) {
          val = CarRentalSystemTypes.RENTLOG
          popup = true
          text = 18133
        } else {
          val = CarRentalSystemTypes.NONE
          text = 18134
          popup = true
        }
      }

      this.setState({
        [name]: val,
        showPopup: popup,
        textKey: text
      })
    }

    const onBlur = (e) => {
      const { value, name } = e.target
      this.setState({
        [name]: value
      }, () => this.onBlur())
    }

    return (
      <Panel title={translation('18135')}>
        <Switch name='selectedRentLog' onChange={onChange} checked={CarRentalSystem === CarRentalSystemTypes.RENTLOG} labelText={translation('18132')} />
        {CarRentalSystem === CarRentalSystemTypes.RENTLOG &&
          <div>
            <Text name='RentLogUserName' value={RentLogUserName} onChange={onChange} onBlur={onBlur} labelText={translation('1')} showValidationIcon={!this.state.CarRentalCredentialsError} />
            <Text name='RentLogPassword' isPassword value={RentLogPassword} onChange={onChange} onBlur={onBlur} labelText={translation('2')} showValidationIcon={!this.state.CarRentalCredentialsError} />
            {this.renderBrancheOfficeListFromRentLog()}
          </div>}
      </Panel>
    )
  }

  renderIdentification () {
    const onChange = (e) => {
      this.setState({
        Identification: parseInt(e.target.value)
      }, () => this.onBlur())
    }

    return (
      <Panel title={translation('15111')} helpText={translation('15121')}>
        <LabelWrapper labelText={translation('15112')}>
          <Radio id='RegNr' name='RegNr' value={0} checked={this.state.Identification === 0} onChange={onChange} labelText={translation('2005')} />
          <Radio id='Brand' name='Brand' value={1} checked={this.state.Identification === 1} onChange={onChange} labelText={translation('145')} />
          <Radio id='Model' name='Model' value={2} checked={this.state.Identification === 2} onChange={onChange} labelText={translation('146')} />
          <Radio id='CarName' name='CarName' value={3} checked={this.state.Identification === 3} onChange={onChange} labelText={translation('15113')} />
        </LabelWrapper>
      </Panel>
    )
  }

  renderBuffer () {
    const onChange = e => {
      const { name, value } = e.target
      this.setState({
        [name]: value
      })
    }

    const onBlur = e => {
      const { name, value } = e.target
      this.setState({
        [name]: isNaN(parseInt(value)) ? 0 : parseInt(value)
      }, () => this.onBlur())
    }

    const { BufferBefore, BufferAfter } = this.state
    return (
      <Panel title={translation('15114')} helpText={translation('15120')}>
        <Text name='BufferBefore' value={BufferBefore} onChange={onChange} onBlur={onBlur} labelText={translation('15115')} />
        <Text name='BufferAfter' value={BufferAfter} onChange={onChange} onBlur={onBlur} labelText={translation('15116')} />
      </Panel>
    )
  }

  renderView () {
    const onChange = e => {
      this.setState({
        [e.target.name]: e.target.checked
      }, () => this.onBlur())
    }

    const { ShowClosedDays, Show24Hours } = this.state
    return (
      <Panel title={translation('15117')}>
        <Switch name='ShowClosedDays' onChange={onChange} checked={ShowClosedDays} labelText={translation('15118')} helpText={translation('15124')} />
        <Switch name='Show24Hours' onChange={onChange} checked={Show24Hours} labelText={translation('15119')} helpText={translation('15123')} />
      </Panel>
    )
  }

  renderContract () {
    const onChange = e => {
      const { name, value } = e.target
      this.setState({
        [name]: value
      })
    }

    const onBlur = e => {
      const { name, value } = e
      this.setState({
        [name]: isNaN(value) ? 0 : value
      }, () => this.onBlur())
    }

    const { StandardConditions, StandardPrice } = this.state
    return (
      <Panel title={translation('16779')}>
        <Textarea name='StandardConditions' value={StandardConditions} onChange={onChange} onBlur={this.onBlur} labelText={translation('16778')} />
        <DecimalInput name='StandardPrice' decimals={2} value={StandardPrice} onChange={onChange} onBlur={onBlur} labelText={translation('16780')} />
      </Panel>
    )
  }

  renderAlternatives () {
    const renderNew = () => {
      const addItem = () => {
        this.setState({
          CarRentalAlts: [ ...this.state.CarRentalAlts, this.state.NewItem ]
        }, () => this.onBlur())
      }
      const onChange = e => {
        this.setState({
          NewItem: {
            ...this.state.NewItem,
            Active: e.target.value.length > 0,
            Name: e.target.value
          }
        })
      }
      return (
        <Grid cols={['min-content', 1, 'min-content']} align='center'>
          <Check name='Active' checked={this.state.NewItem.Active} simple />
          <Text name='Name' value={this.state.NewItem.Name} onChange={onChange} />
          <AddButton onClick={addItem} />
        </Grid>
      )
    }
    const renderAltRentalCars = (val, key) => {
      const onChange = e => {
        let CarRentalAltsNew = [...this.state.CarRentalAlts]
        CarRentalAltsNew[key].Active = e.target.checked
        this.setState({
          CarRentalAlts: CarRentalAltsNew
        }, () => this.onBlur())
      }
      const deleteItem = (key) => {
        let CarRentalAlts = [...this.state.CarRentalAlts]
        CarRentalAlts[key].IsDeleted = true
        this.setState({
          CarRentalAlts: CarRentalAlts
        }, () => this.onBlur())
      }
      return (
        <Grid key={key} cols={[1, 'min-content']} align='center'>
          <Check labelText={val.Name} checked={val.Active} onChange={onChange} />
          <RemoveButton onClick={deleteItem.bind(this, key)} size='m' />
        </Grid>
      )
    }
    return (
      <Panel title={translation('16751')}>
        <Label>{translation('295')}</Label>
        {this.state.CarRentalAlts.length > 0 && this.state.CarRentalAlts.map(renderAltRentalCars)}
        {renderNew()}
      </Panel>
    )
  }

  render () {
    let noneIntegration = this.state.CarRentalSystem === CarRentalSystemTypes.NONE
    return (
      <div className='carrental'>
        <Row>
          <Col>
            {this.renderIdentification()}
            {this.renderBuffer()}
            {this.renderView()}
          </Col>
          <Col span={3}>
            {this.renderAlternatives()}
            {this.renderPopupMessage()}
            {this.renderRentLogIntegration()}
          </Col>
          <Col span={5}>
            {noneIntegration && this.renderContract()}
          </Col>
        </Row>
      </div>
    )
  }
}

CarRental.contextTypes = {
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getCarRentalInformation,
  saveCarRentalInformation
})(CarRental)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/CarRental/index.js